import DecisionContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/DecisionContent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import TrackString from "../../../analytics/TrackString";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTDialogFactory from "../../dialog/NGTDialogFactory";
import NGTDialogPlayer from "../../dialog/NGTDialogPlayer";
import ScenarioPlayerEvent from "../../scenario/ScenarioPlayerEvent";
import DialogPlayerRegisterEvent from "../../dialog/controller/DialogPlayerRegisterEvent";

export default class PlayDecisionDialogCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {NGTDialogPlayer} dialogPlayer 
     * @param {NGTDialogFactory} dialogFactory 
     */
    constructor(dispatcher, dialogPlayer, dialogFactory) {
        super(dispatcher);

        this._dialogPlayer = dialogPlayer;
        this._dialogFactory = dialogFactory;
    }

    execute(evt) {
        const data = evt.params.data;

        /** @type {DecisionContent} */
        const content = data.content;
        const contentPlayer = data.contentPlayer;

        this._dialogPlayer.setContentPlayer(contentPlayer);
        this._dialogPlayer.setContent(content);

        const dialogId = content.getDecisionDialogID();
        const dialog = this._dialogFactory.getDialog(dialogId);
        this._dialogPlayer.setDialog(dialogId, dialog);

        const dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.REGISTER, this._dialogPlayer);
        this.dispatch(dprEvent.type, dprEvent);

        // Analytics: Sends decision dialog start
        this.trackEvent(TrackString.EVENT_DECISION_DIALOG_START, TrackString.createDialogParams(dialogId));

        this._decisionScreen = this.openScreen(SkinKeyRegistry.DECISION_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 350, createjs.Ease.sineInOut),
        }, {
            dialogPlayer: this._dialogPlayer
        });

        this._handleContentCompletedBound = this._handleContentCompleted.bind(this);
        this._dispatcher.addEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound);

        this._dialogPlayer.viewContent();
    }

    destroy() {
        this._dialogPlayer.destroy();
    }

    _handleContentCompleted(evt) {
        const data = evt.params.data;
        /** @type {DecisionContent} */
        const content = data.content;

        if (content !== this._dialogPlayer.getContent()) {
            return;
        }

        const dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.DEREGISTER, this._dialogPlayer);
        this.dispatch(dprEvent.type, dprEvent);
        
        // Analytics: Sends decision dialog end
        const dialogId = content.getDecisionDialogID();
        this.trackEvent(TrackString.EVENT_DECISION_DIALOG_END, TrackString.createDialogParams(dialogId));

        this._dispatcher.removeEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound);

        this.closeScreen(this._decisionScreen, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 350, createjs.Ease.sineInOut),
        });

        this.destroy();
    }
}